// User is set by API-gateway in request headers
// So here we need to just extract and validate it
import jwt from 'jsonwebtoken';
import {GraphQLResolveInfo} from "graphql";

export default (resolve, parent, args, context, info: GraphQLResolveInfo) => {
    // TODO
    if (!context.user && context.request.get("authorization")) {
        try {
            const token = context.request.get("authorization").split(' ')[1];
            const userToken = jwt.verify(token, process.env.APP_KEY);
            context.user = userToken;
            context.request.user = userToken;
        } catch (e) {
            // token not valid — do nothing
        }
    }
    return resolve(parent, args, context, info);
}
